// extracted by mini-css-extract-plugin
export default {"ModalBase":"ModalBase_ModalBase__takHV","Overlay":"ModalBase_Overlay__t7qFv"};